import { Typography } from '@mui/material'

import { useStyles } from './styles'
import { ActionList } from './actions-section/action-list'
import { useTranslation } from 'react-i18next'
import { HelperWrapper } from '../helper-wrapper'

export const UserDashboardComponent = () => {
  const [t] = useTranslation()

  const classes = useStyles()

  return (
    <div className={classes.wrapperContainer}>
      <Typography variant="body1" fontWeight={600} sx={{ mb: '20px' }}>
        <HelperWrapper t="user-dashboard-welcome-title" />
      </Typography>
      <Typography variant="body2" fontWeight={500}>
        <HelperWrapper t="user-dashboard-welcome-subtitle" />
      </Typography>
      <Typography variant="body2" fontWeight={500} sx={{ mb: '25px' }}>
        <HelperWrapper t="user-dashboard-welcome-subtitle-2" />
      </Typography>

      <ActionList />
    </div>
  )
}
